export default "__VITE_ASSET__CmR2IM1d__"